/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import React from "react";
import { FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { UseFormReturnType } from "@mantine/form";
import { SummaryNotificationConfig } from "../../interfaces/Global";
import EmployeesFilterForm from "../../components/EmployeesFilterForm";

export interface ConfigEmployeesProps {
	form: UseFormReturnType<SummaryNotificationConfig>;
}

export default function ConfigEmployees({ form }: ConfigEmployeesProps) {

	return (
		<Stack spacing={1} mb={2}>
			<RadioGroup
				{...form.getInputProps('employeesSource')}
			>
				<FormControlLabel value="calendar" control={<Radio />} label="From linked calendar"/>
				<FormControlLabel value="filter" control={<Radio />} label="Custom selection"/>
			</RadioGroup>
			{form.values.employeesSource === "filter" &&
				<EmployeesFilterForm
					filter={form.values.employeesFilter ?? [["+", "managerId", []]]}
					setFilter={(filter) => form.setFieldValue('employeesFilter', filter)}
				/>
			}
		</Stack>
	);

}